import React from "react";
import { Link, useLocation } from "react-router-dom";
import logoOne from '../assets/images/logo1.png'
import Flash from '../assets/images/flash.png'
import Flash1 from '../assets/images/flash1.svg'
import Kurlon from '../assets/images/kurlon.png'
import Kurlon1 from '../assets/images/kurlon1.png'
import Sleepwell from '../assets/images/sleepwell.png'
import Sleepwell1 from '../assets/images/sleepwell1.png'
import Clock from '../assets/images/clock.png'
import Clock1 from '../assets/images/clock1.svg'
import Trends from '../assets/images/trends.png'
import Trends1 from '../assets/images/trends1.png'
import Reports from '../assets/images/reports.png'
import Reports1 from '../assets/images/reports1.png'

const Sidebar = ({ isOpen, toggleSidebar }) => {

  const location = useLocation();

  const menuItems = [
    { path: "/dashboard/flash", icon: Flash1, activeIcon: Flash, label: "Flash" },
    { path: "/dashboard/kurlon", icon: Kurlon, activeIcon: Kurlon1, label: <>Kurl-On<br />Price</> },
    { path: "/dashboard/sleepwell", icon: Sleepwell, activeIcon: Sleepwell1, label: <>Sleepwell<br />Price</> },
    { path: "/dashboard/availability", icon: Clock1, activeIcon: Clock, label: "Availability" },
    { path: "/dashboard/trends", icon: Trends1, activeIcon: Trends, label: "Trends" },
    { path: "/dashboard/reports", icon: Reports, activeIcon: Reports1, label: "Reports" },
  ];

  return (
    <div className={`sidebar ${isOpen ? "open" : ""}`}>

      <button
        type="button"
        onClick={toggleSidebar}
        className="btn-close d-block d-sm-none top-0 end-0 m-3"
        aria-label="Close"
      ></button>

      <img className="mb-4" src={logoOne} alt="" style={{ height: "41px", width: "41px", marginTop: 35 }} />
      <nav onClick={toggleSidebar} className="mt-3">
        {menuItems.map(item => {
          const isActive = location.pathname === item.path;
          return (
            <Link to={item.path} key={item.path} className={`sidebar-link ${isActive ? "active" : ""}`}>
              <img
                className=""
                src={isActive ? item?.activeIcon : item?.icon}
                alt={item.label}
                style={{ height: "24px", width: "24px", }}
              />
              <p className="text-center mt-2 activemenu">{isActive && <span>{item.label}</span>}</p>
            </Link>
          );
        })}
      </nav>
    </div>
  );
};

export default Sidebar;
